module.exports = __webpack_public_path__ + "img/main_img2.c97fb77f.png";